import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8tp4283yy: FaireProductEntity = {
  token: "p_g8tp4283yy",
  type: "product",
  name: "Sweet Dreams Natural Deodorant Refill – Lavender & Lemon",
  brandToken: "b_7t7wu79e8q",
  brandName: "Terra and Self",
  imageUrl:
    "https://cdn.faire.com/fastly/c82cce54dde5add5532a30c056f7e61f594322433bad72396b92b376ecf7aa7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/180936002f01340b30684e4d7a46aef28cc218778f6573237b5f9bfaff89f967.jpeg",
    "https://cdn.faire.com/fastly/cfa27567765f0ecc7eae80192bae9d6747612a6e4f8674cea00022c3566b0aed.png",
    "https://cdn.faire.com/fastly/a4c21f35c109ae49282cbdd5b64be1917145abe9c1e70721810389fa9a17a471.png",
    "https://cdn.faire.com/fastly/1324d8978b7e43796e5d993df7e562f9538ce5ea5d0ed41dfd4224a68dda98e0.png",
  ],
  priceDollars: 6.24,
  description:
    "Sweet Dreams smells like winding down and exhaling at the end of a long day. Calming lavender leads the way, softened by gentle chamomile and creamy vanilla, with a light splash of lemon to keep things fresh and clean. It’s cozy, soothing, and perfectly balanced, like slipping into clean sheets after a warm shower. Powered by magnesium for all day odor protection that never quits.\n\nFeatures:\n-Plastic free and fully compostable refill\n-Gentle, aluminum free, and baking soda free formula\n-Magnesium powered odor protection that lasts all day\n-Smooth texture that won’t stain or irritate skin\n-Soft, calming, and lightly fresh scent profile\n-Designed for Terra & Self refillable deodorant tubes\n-Vegan, cruelty free, handcrafted in small batches\n",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:03.713Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
